import React from "react";
import IntlMessages from "@util/IntlMessages";
import NewsletterListDataSettings from "./NewsletterListDataSettings";
import GlobalSettings from "../GlobalSettings/GlobalSettingsModal";
import { Tabs } from "../../../BP2Components";
import TabPane from "../../../BP2Components/Tabs/TabPane";

const NewsletterListModal = (props) => {
   return (
      <Tabs defaultActiveKey="1">
         <TabPane tab={<IntlMessages id="settings.globalSettings" />} key="1">
            <GlobalSettings {...props} />
         </TabPane>
         <TabPane tab={<IntlMessages id="settings.dataSettings" />} key="3">
            <NewsletterListDataSettings {...props} />
         </TabPane>
      </Tabs>
   );
};

export default NewsletterListModal;
